import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {GetProductList} from '../../Redux/AdminPanel/PurchaseCreditSlice'
import CustomCreditPurchasePopup from './modal/CustomCreditPurchasePopup'
import {Elements} from '@stripe/react-stripe-js'
import CardPaymentPopup from './modal/CardPaymentPopup'
import {
  FeGetPriceRuleList,
  GetPriceRuleList,
} from '../AdminPages/Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import {GeneralDataOFLoginUser} from '../../Utils/Auth'
import {ENV} from '../../Utils/_helpers/EnvHelper'
import StripeJSProvider from '../../Utils/StripeJSProvider'

const PurchaseCredits = () => {
  const dispatch = useDispatch()
  const accountId = GeneralDataOFLoginUser()?.user?.accountId
  ////////////////////////////USESTATE///////////////////////////////////////////////
  const [open, setOpen] = useState(false)
  const [card, setCard] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any>([])

  const [customCredit, setCustomCredit] = useState({
    priceperItems: 0,
    type: 'sms',
    credits: 0,
  })

  ///////////////////////////////////////////USE  EFFECT///////////////////////

  useEffect(() => {
    dispatch(GetProductList())
    dispatch(FeGetPriceRuleList({accountId: accountId}))
  }, [])
  /////////////////////////////////////////USE MEMO////////////////////////////////////////////

  const payment = useMemo(
    () => (
      <CustomCreditPurchasePopup
        select={setSelectedItem}
        pay={() => setCard(true)}
        setCustomCredit={setCustomCredit}
        customCredit={customCredit}
        show={open}
        handleClose={() => setOpen(false)}
      />
    ),
    [open]
  )

  ///////////////////////////////////////////useSelector///////////////////////////

  const PriceRateListSMS = useSelector((state: any) => state?.priceRules?.RateCardList)?.filter(
    (key: any) => key?.type == 'SMS'
  )
  const PriceRateListMMS = useSelector((state: any) => state?.priceRules?.RateCardList)?.filter(
    (key: any) => key?.type == 'MMS'
  )
  const ProductListmms = useSelector((state: any) => state?.productList?.productList)?.filter(
    (key: any) => key?.metadata?.type == 'mms'
  )
  const ProductListsms = useSelector((state: any) => state?.productList?.productList)?.filter(
    (key: any) => key?.metadata?.type == 'sms'
  )

  ////////////////////////////////////function////////////////////////////////////////
  const totalMMS = () => {
    let x = selectedItem
      ?.filter((key: any) => key?.type == 'mms')
      ?.map((key: any) => key?.priceperItems * key?.credits * key?.prod_qty)
      .reduce(function (x: number, y: number) {
        return x + y
      }, 0)

    return x
  }
  const totalSMS = () => {
    let x = selectedItem
      ?.filter((key: any) => key?.type == 'sms')
      ?.map((key: any) => key?.priceperItems * key?.credits * key?.prod_qty)
      .reduce(function (x: number, y: number) {
        return x + y
      }, 0)

    return x
  }

  const totalSmsCredit = () => {
    let total = selectedItem
      ?.filter((key: any) => key?.type == 'sms')
      ?.map((key: any) => key?.credits * key?.prod_qty)
      .reduce(function (x: number, y: number) {
        return +x + +y
      }, 0)

    return total
  }
  const totalMmsCredit = () => {
    let total = selectedItem
      ?.filter((key: any) => key?.type == 'mms')
      ?.map((key: any) => key?.credits * key?.prod_qty)
      .reduce(function (x: number, y: number) {
        return +x + +y
      }, 0)

    return total
  }

  const removeOnClick = (id: number, e: any) => {
    let data = selectedItem?.map((key: any) =>
      key?.prod_id == id && key?.prod_qty !== 1
        ? {
            ...key,

            prod_qty: key?.prod_qty - 1,
          }
        : key
    )
    setSelectedItem(data)
  }
  const addOnClick = (id: number, e: any) => {
    let data = selectedItem?.map((key: any) =>
      key?.prod_id == id
        ? {
            ...key,

            prod_qty: key?.prod_qty + 1,
          }
        : key
    )
    setSelectedItem(data)
  }

  const handleClick = (data: any) => {
    if (!(selectedItem?.filter((key: any) => key?.prod_id == data?.id)?.length == 1)) {
      if (data?.metadata?.type == 'sms') {
        let price =
          PriceRateListSMS?.find(
            (key: any) =>
              key?.creditendrange >= +data?.metadata?.qty &&
              key?.creditstartrange <= +data?.metadata?.qty
          ) == undefined
            ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
              PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange >= +data?.metadata?.qty &&
                  key?.creditstartrange <= +data?.metadata?.qty
              )?.finalPrice

        setSelectedItem([
          ...selectedItem,

          {
            prod_id: data?.id,
            prod_qty: 1,
            type: data?.metadata?.type,
            priceperItems: price,
            credits: data?.metadata?.qty,
            total: (data?.metadata?.qty * price).toPrecision(3),
          },
        ])
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: any) =>
              key?.creditendrange >= +data?.metadata?.qty &&
              key?.creditstartrange <= +data?.metadata?.qty
          ) == undefined
            ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
              PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
              )?.finalPrice
            : PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange >= +data?.metadata?.qty &&
                  key?.creditstartrange <= +data?.metadata?.qty
              )?.finalPrice

        setSelectedItem([
          ...selectedItem,
          {
            prod_id: data?.id,
            prod_qty: 1,
            type: data?.metadata?.type,
            priceperItems: price,
            credits: data?.metadata?.qty,
            total: (data?.metadata?.qty * price).toPrecision(3),
          },
        ])
      }
    }
  }

  const intToString = (value: any) => {
    var suffixes = ['', 'k', 'm', 'b', 't']
    var suffixNum = Math.floor(('' + value).length / 20)
    var shortValue: any = parseFloat(suffixNum != 0 ? value / Math.pow(1000, suffixNum) : value)
    if (shortValue % 1 != 0) {
      shortValue = shortValue.toFixed(1)
    }
    return shortValue + suffixes[suffixNum]
  }

  const AddToCart = (id: number, e: any) => {
    if (e.target.value == '') {
      let data = selectedItem?.map((key: any) => (key?.prod_id == id ? {...key, prod_qty: 1} : key))

      setSelectedItem(data)
    } else {
      let data = selectedItem?.map((key: any) =>
        key?.prod_id == id
          ? {
              ...key,

              prod_qty: e.target.value,
            }
          : key
      )
      setSelectedItem(data)
    }
  }

  const removeItemCart = (val: any) => {
    let index = selectedItem?.findIndex((key: any) => key?.prod_id === val?.prod_id)
    let y = selectedItem?.splice(index, 1)
    setSelectedItem([...selectedItem])
  }

  return (
    <>
      <div className='row'>
        <div className='col-8'>
          <div className='card mb-0'>
            <div className='card-header card-header-stretch border-bottom-0 px-5'>
              <div className='card-title d-flex flex-column mt-5'>
                <h3 className='fw-bolder m-0'>Select your bundle</h3>
                <span className='fs-7 text-gray-400 fw-normal'>
                  MMS and SMS bundles available. Click desire bundle to add to your order. Note
                  sure?
                  {/* <a href='' className='ms-2 text-decoration-underline'>
                    See calculator
                  </a> */}
                </span>
              </div>

              <div className='card-toolbar m-0'>
                <div className='d-flex gap-3 align-items-center'>
                  <button
                    onClick={() => {
                      setOpen(true)
                    }}
                    className='btn btn-primary'
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
            <div className='card-body pt-2 px-5'>
              <div className='row'>
                <div className='tab-content col-6'>
                  <div className='table-responsive'>
                    <h4 className='border-bottom-dashed border-2 border-gray-300 pb-4 fs-5 mb-8 text-uppercase'>
                      SMS
                    </h4>
                    <div className='gs-0 gy-4 text-gray-600'>
                      {ProductListsms?.map((data: any, id: number) => {
                        return (
                          <div
                            className={`d-flex w-100 gap-5 align-items-center border px-4 py-4 rounded mb-2 bg-hover-light-dark
                            ${
                              selectedItem?.filter((key: any) => key?.prod_id == data?.id)
                                ?.length == 1 && 'bg-light-success'
                            }`}
                            key={id}
                            onClick={() => handleClick(data)}
                          >
                            <div className='h-100 bg-light-primary text-primary d-flex py-4 px-2 rounded fw-bold w-50px text-uppercase flex-column-auto justify-content-center'>
                              {data?.metadata?.type}
                            </div>
                            <div className='d-flex justify-content-between w-100 gap-10 align-items-center'>
                              <div>
                                <h5 className='fs-3 mb-0'>{data?.name}</h5>
                                <span className='text-gray-400'>
                                  {PriceRateListSMS?.find(
                                    (key: any) =>
                                      key?.creditendrange >= +data?.metadata?.qty &&
                                      key?.creditstartrange <= +data?.metadata?.qty
                                  ) == undefined
                                    ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
                                      PriceRateListSMS?.find(
                                        (key: any) =>
                                          key?.creditendrange ===
                                          Math.max(
                                            ...PriceRateListSMS.map((o: any) => o?.creditendrange)
                                          )
                                      )?.finalPrice
                                    : PriceRateListSMS?.find(
                                        (key: any) =>
                                          key?.creditendrange >= +data?.metadata?.qty &&
                                          key?.creditstartrange <= +data?.metadata?.qty
                                      )?.finalPrice}
                                  /credit
                                </span>
                              </div>
                            </div>
                            <div>
                              <h2>
                                $
                                {intToString(
                                  (
                                    (PriceRateListSMS?.find(
                                      (key: any) =>
                                        key?.creditendrange >= +data?.metadata?.qty &&
                                        key?.creditstartrange <= +data?.metadata?.qty
                                    ) == undefined
                                      ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
                                        PriceRateListSMS?.find(
                                          (key: any) =>
                                            key?.creditendrange ===
                                            Math.max(
                                              ...PriceRateListSMS.map((o: any) => o?.creditendrange)
                                            )
                                        )?.finalPrice
                                      : PriceRateListSMS?.find(
                                          (key: any) =>
                                            key?.creditendrange >= +data?.metadata?.qty &&
                                            key?.creditstartrange <= +data?.metadata?.qty
                                        )?.finalPrice) * data?.metadata?.qty
                                  ).toFixed(2)
                                )}
                              </h2>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
                <div className='tab-content col-6'>
                  <div className='table-responsive'>
                    <h4 className='border-bottom-dashed border-2 border-gray-300 pb-4 fs-5 mb-8 text-uppercase'>
                      MMS
                    </h4>
                    <div className='gs-0 gy-4 text-gray-600'>
                      {ProductListmms?.map((data: any, id: number) => {
                        return (
                          <div
                            className={`d-flex w-100 gap-5 align-items-center border px-4 py-4 rounded mb-2 bg-hover-light-dark
                          ${
                            selectedItem?.filter((key: any) => key?.prod_id == data?.id)?.length ==
                              1 && 'bg-light-success'
                          }`}
                            key={id}
                            onClick={() => handleClick(data)}
                          >
                            <div className='h-100 bg-light-success text-success d-flex py-4 px-2 rounded fw-bold w-50px text-uppercase flex-column-auto justify-content-center'>
                              {data?.metadata?.type}
                            </div>
                            <div className='d-flex justify-content-between w-100 gap-10 align-items-center'>
                              <div>
                                <h5 className='fs-3 mb-0'>{data?.name}</h5>
                                <span className='text-gray-400'>
                                  {PriceRateListMMS?.find(
                                    (key: any) =>
                                      key?.creditendrange >= +data?.metadata?.qty &&
                                      key?.creditstartrange <= +data?.metadata?.qty
                                  ) == undefined
                                    ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
                                      PriceRateListMMS?.find(
                                        (key: any) =>
                                          key?.creditendrange ===
                                          Math.max(
                                            ...PriceRateListMMS.map((o: any) => o?.creditendrange)
                                          )
                                      )?.finalPrice
                                    : PriceRateListMMS?.find(
                                        (key: any) =>
                                          key?.creditendrange >= +data?.metadata?.qty &&
                                          key?.creditstartrange <= +data?.metadata?.qty
                                      )?.finalPrice}
                                  /credit
                                </span>
                              </div>
                              <div>
                                <h2>
                                  $
                                  {intToString(
                                    (PriceRateListMMS?.find(
                                      (key: any) =>
                                        key?.creditendrange >= +data?.metadata?.qty &&
                                        key?.creditstartrange <= +data?.metadata?.qty
                                    ) == undefined
                                      ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
                                        PriceRateListMMS?.find(
                                          (key: any) =>
                                            key?.creditendrange ===
                                            Math.max(
                                              ...PriceRateListMMS.map((o: any) => o?.creditendrange)
                                            )
                                        )?.finalPrice
                                      : PriceRateListMMS?.find(
                                          (key: any) =>
                                            key?.creditendrange >= +data?.metadata?.qty &&
                                            key?.creditstartrange <= +data?.metadata?.qty
                                        )?.finalPrice) * data?.metadata?.qty
                                  )}
                                </h2>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-4'>
          <div className='card mb-0'>
            <div className='card-header card-header-stretch border-bottom-0 px-5'>
              <div className='card-title d-flex flex-column mt-7 mb-10'>
                <h3 className='fw-bolder m-0'>Order summary</h3>
              </div>
              {selectedItem?.length == 0 && (
                <div className='d-flex flex-column justify-content-center align-items-center text-gray-400 fs-8 text-center border border-1 border-gray-200 border-hover-primary bg-hover-lighten px-5 py-7 rounded'>
                  <div className='w-100px h-100px d-flex bg-gray-100 rounded-pill align-items-center justify-content-center mb-5'>
                    <i className='fa fa-arrow-left fs-2tx'></i>
                  </div>
                  <h6>Select your bundle </h6>
                  <p>
                    Select one or more bundles from the list on the left by clicking on the card.
                  </p>
                </div>
              )}
              {selectedItem?.length > 0 &&
                selectedItem?.map((val: any, id: number) => (
                  <div key={id} className='d-flex align-items-center gap-3 w-100'>
                    <div className='d-flex w-100 gap-5 align-items-center border px-4 py-4 rounded mb-2'>
                      <div className='h-100 bg-light-primary text-primary d-flex py-4 px-2 rounded fw-bold w-50px text-uppercase flex-column-auto justify-content-center'>
                        {val?.type}
                      </div>
                      <div className='d-flex justify-content-between w-100 gap-5 align-items-center'>
                        <div>
                          <h5 className='fs-3 mb-0'>{val?.credits * val?.prod_qty}</h5>
                          <span className='text-gray-400'> {val?.priceperItems}/credit</span>
                          <span className='text-gray-400 d-block'>Quantity: {val?.prod_qty}</span>
                          <div className='d-flex gap-1'>
                            <button
                              onClick={(e: any) => removeOnClick(val?.prod_id, e)}
                              type='button'
                              className='btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-20px w-20px'
                              data-kt-table-widget-4='expand_row'
                            >
                              <span className='svg-icon svg-icon-3 m-0'>
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='24px'
                                  height='24px'
                                  viewBox='0 0 24 24'
                                  version='1.1'
                                >
                                  <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                                    <rect
                                      fill='currentColor'
                                      x='4'
                                      y='11'
                                      width='16'
                                      height='2'
                                      rx='1'
                                    />
                                  </g>
                                </svg>
                              </span>
                            </button>
                            <input
                              onChange={(e: any) => AddToCart(val?.prod_id, e)}
                              value={val?.prod_qty}
                              type='number'
                              className='form-control w-40px h-20px py-0 px-1 text-center fs-7'
                            />
                            <button
                              onClick={(e: any) => addOnClick(val?.prod_id, e)}
                              type='button'
                              className='btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-20px w-20px'
                              data-kt-table-widget-4='expand_row'
                            >
                              <span className='svg-icon svg-icon-3 m-0'>
                                <svg
                                  width='24'
                                  height='24'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <rect
                                    opacity='0.5'
                                    x='11'
                                    y='18'
                                    width='12'
                                    height='2'
                                    rx='1'
                                    transform='rotate(-90 11 18)'
                                    fill='currentColor'
                                  />
                                  <rect
                                    x='6'
                                    y='11'
                                    width='12'
                                    height='2'
                                    rx='1'
                                    fill='currentColor'
                                  />
                                </svg>
                              </span>
                              <span className='svg-icon svg-icon-3 m-0 toggle-on'>
                                <svg
                                  width='24'
                                  height='24'
                                  viewBox='0 0 24 24'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <rect
                                    x='6'
                                    y='11'
                                    width='12'
                                    height='2'
                                    rx='1'
                                    fill='currentColor'
                                  />
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                        <div>
                          <h2>${intToString(val?.total * val?.prod_qty)}</h2>
                        </div>
                      </div>
                    </div>
                    <span
                      onClick={() => removeItemCart(val)}
                      className='btn btn-icon btn-circle btn-color btn-active-color-primary w-15px h-15px bg-light-danger text-danger bg-hover-danger text-hover-white'
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='25'
                        height='25'
                        fill='currentColor'
                        className='bi bi-x'
                        viewBox='0 0 16 16'
                      >
                        <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                      </svg>
                    </span>
                  </div>
                ))}
            </div>

            <div className='px-5 py-10'>
              <h4 className='text-gray-500 fw-bold mb-5 d-flex justify-content-between'>
                <span>Total MMS:</span>{' '}
                <span className='text-black'>
                  {}
                  {`${totalMmsCredit()} Credits - $${totalMMS().toFixed(2)}`}
                </span>
              </h4>
              <h4 className='text-gray-500 fw-bold mb-5 d-flex justify-content-between'>
                <span>Total SMS:</span>
                <span className='text-black'>{`${totalSmsCredit()} Credits - $${totalSMS().toFixed(
                  2
                )}`}</span>
              </h4>
              <h4 className='text-gray-500 fw-bold mb-5 d-flex justify-content-between'>
                <span>GST: </span>
                <span className='text-black'>${((totalMMS() + totalSMS()) * 0.1)?.toFixed(2)}</span>
              </h4>
              <h4 className='text-gray-500 fw-bold border-top pt-10 d-flex justify-content-between align-items-center'>
                <h3>Total cost:</h3>
                <span className='text-black fw-boldest fs-xl-2x'>
                  ${(totalMMS() + totalSMS() + (totalMMS() + totalSMS()) * 0.1)?.toFixed(2)}
                </span>
              </h4>
            </div>
            <div className='px-5 pb-10'>
              {/* 
            <Elements stripe={stripeTestPromise} >
      <Checkout />
    </Elements> */}
              <button
                disabled={totalMMS() + totalSMS() == 0}
                onClick={() => setCard(true)}
                className='btn btn-primary'
              >
                Checkout
              </button>

              <StripeJSProvider>
                {({stripe}: any) =>
                  stripe ? (
                    <Elements stripe={stripe}>
                      {payment}
                      {customCredit?.credits > 0 ? (
                        <CardPaymentPopup
                          show={card}
                          handleClose={() => setCard(false)}
                          customData={customCredit}
                          total={customCredit?.credits * customCredit?.priceperItems}
                        />
                      ) : (
                        <CardPaymentPopup
                          show={card}
                          handleClose={() => setCard(false)}
                          data={selectedItem}
                          setData={setSelectedItem}
                          total={totalMMS() + totalSMS()}
                        />
                      )}
                    </Elements>
                  ) : null
                }
              </StripeJSProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PurchaseCredits
